import React from 'react';

import { Text } from '@betterment/samba-react';

import { BulkFeeIntentStatus } from '../../../../graphql/schema';
import { BulkFeeIntentProps } from '../data';

export const BulkFeeIntentStatusComponent: React.FC<BulkFeeIntentProps> = ({ bulkFeeIntent }) => {
  if (bulkFeeIntent.status === BulkFeeIntentStatus.Processing) {
    return (
      <Text as="span" color="text" variant="text100" css={{ fontWeight: '400' }}>
        {bulkFeeIntent.submittedCount} processing
      </Text>
    );
  }

  const failedCount = bulkFeeIntent.failedCount ?? 0;

  if (failedCount === 0) {
    return (
      <Text as="span" color="text" variant="text100" css={{ fontWeight: '400' }}>
        {bulkFeeIntent.submittedCount} completed
      </Text>
    );
  }

  if (failedCount === bulkFeeIntent.submittedCount) {
    return (
      <Text as="span" color="text.critical">
        {failedCount} failed
      </Text>
    );
  }

  const completedCount = bulkFeeIntent.submittedCount - failedCount;
  return (
    <Text as="span" color="text" variant="text100" css={{ fontWeight: '400' }}>
      {completedCount} completed,{' '}
      <Text as="span" color="text.critical">
        {failedCount} failed
      </Text>
    </Text>
  );
};
